import { SIZE } from 'common/sizes';
import styled from 'styled-components';


export const DatesFromToMainContainer = styled.div`
    margin-left: 29px;
    position: relative;
`

export const FromToToolTipContainer = styled.div`
    position: absolute;
    width: 270px;
    z-index: 1000;
    display: none;
    margin: -40px 0px 0px -295px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
`;

export const DatesFromToContainer = styled.div`
    margin: 0px 0px 0px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &:hover + ${FromToToolTipContainer} {
        display: flex;
      }
`
export const DatesToolTipContainer = styled.div`
    position: absolute;
    width: 245px;
    z-index: 100;
    display: none;
    margin: 64px 0px 0px -65px;
    padding: 6px 7.5px 6px 7.6px;
    border-radius: 2px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #707070;
`;


export const DatesToolTipText = styled.div`
  font-family: Rubik;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;


`;

export const DatesInfoIconContainer = styled.div`
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 10px;
    cursor: pointer;
    display:flex;
    &:hover + ${DatesToolTipContainer} {
        display: flex;
      }
`

export const DatesCalendarIconContainer = styled.div`
    margin: 0px 0px 0px 0px;
    padding: 0px 10px 0px 0px;
`

export const DatesFromToText = styled.span`
    font-family: Lato;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #122442;
`